import { render, staticRenderFns } from "./NoteCode.vue?vue&type=template&id=39f6796f&scoped=true&"
import script from "./NoteCode.vue?vue&type=script&lang=js&"
export * from "./NoteCode.vue?vue&type=script&lang=js&"
import style0 from "./NoteCode.vue?vue&type=style&index=0&id=39f6796f&prod&scoped=true&lang=css&"
import style1 from "./NoteCode.vue?vue&type=style&index=1&id=39f6796f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6796f",
  null
  
)

export default component.exports